var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Grid, TileHeader, TileComment, Tile, GridHeader, TileHeaderAddButton, } from '../common/Tile';
import { ToolbarWithBackAndEditButtons } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { EntityHeader } from '../common/EntityHeader';
import Loading from '../common/Loading';
import { useRouter } from '../../context/router-context';
import { useViewer } from '../../context/viewer-context';
import MembersTile from './MembersTile';
import View from '../common/View';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { useOrganizationDetailsQuery, UserRole, } from '../../__generated__/graphql';
var content = [
    {
        label: 'Manage Advice and Work',
        items: [
            {
                label: 'Advice',
                comment: 'Active requests for advice',
            },
            {
                label: 'Hiring',
                comment: 'Active requests for temporary or fixed positions, either contracting or employees',
            },
            {
                label: 'Projects and Service Providers',
                comment: 'Manage projects and enagging service providers and staffing for them',
            },
            {
                label: 'Compensation and Benefits',
                comment: 'Manage compensation and benefits for employees and contractors',
            },
        ],
    },
    {
        label: 'Manage company development',
        items: [
            {
                label: 'KPIs',
                comment: 'Manage your Key Performance Indicators',
            },
            {
                label: 'Product Market Fit',
                comment: 'Manage your journey to establishing Product Market Fit',
            },
            {
                label: 'Stakeholders',
                comment: 'Manage information sharing to your stakeholders, such as investors, board and advisors',
            },
        ],
    },
    {
        label: 'Manage Equity and Financials',
        items: [
            {
                label: 'Balance',
                comment: 'Current spending balance on the BootstrapWorks Platform, tap here to manage or add more',
            },
            {
                label: 'Accounting',
                comment: 'Manage connections to your accounting system (QuickBooks etc). By connecting your financial system to BootstrapWorks, you will get advice and notifications about important actions to manage your company',
            },
        ],
    },
];
var team = [
    { name: 'Team member', role: 'Member' },
    { name: 'Team member', role: 'Member' },
];
function Toolbar() {
    return (_jsx(ToolbarWithBackAndEditButtons, __assign({ forwardTo: "edit" }, { children: "Manage Company" }), void 0));
}
export default function OrganizationHome(props) {
    var viewer = useViewer().viewer;
    // Router
    var goForwardClick = useRouter().goForwardClick;
    var organizationId = (props.match && props.match.params.organizationId) || '';
    // GraphQL query
    var _a = useOrganizationDetailsQuery({
        variables: { organizationId: organizationId },
    }), data = _a.data, loading = _a.loading;
    var organization = data && data.organization;
    var users = data && data.users;
    if (!viewer) {
        throw new Error('Viewer not found');
    }
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!organization) {
        throw new Error('Organization does not exist');
    }
    if (!users) {
        throw new Error('Users does not exist');
    }
    return (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}, void 0),
            _jsxs(Body, { children: [_jsx(EntityHeader, { label: organization.name, comment: organization.description, icon: "organization" }, void 0),
                    _jsxs(Grid, { children: [_jsx(View, __assign({ allowedRoles: [UserRole.DEVELOPER] }, { children: _jsxs(Tile, { children: [_jsxs(TileHeader, { children: ["Team", _jsx(TileHeaderAddButton, {}, void 0)] }, void 0),
                                        _jsx(TileComment, { children: "Current team of founders, co-founders and management team" }, void 0),
                                        _jsx(List, { children: team.map(function (_a, i) {
                                                var name = _a.name, role = _a.role;
                                                return (_jsx(ListItem, { primary: name, label: role, chevron: true, onClick: goForwardClick('/organizations/c') }, i));
                                            }) }, void 0)] }, void 0) }), void 0),
                            _jsx(View, __assign({ allowedRoles: [UserRole.ORGANIZATION] }, { children: _jsx(MembersTile, { organizationId: organizationId, members: organization.members, users: users }, void 0) }), void 0),
                            _jsx(View, __assign({ allowedRoles: [UserRole.CAP_TABLE] }, { children: _jsxs(Tile, __assign({ onClick: goForwardClick("cap-table") }, { children: [_jsx(TileHeader, { children: "Cap Table" }, void 0),
                                        _jsx(TileComment, { children: "This company uses BootstrapWorks to manage their cap table, tap here to view and manage the cap table" }, void 0)] }), void 0) }), void 0)] }, void 0),
                    _jsx(View, __assign({ allowedRoles: [UserRole.DEVELOPER] }, { children: _jsx(_Fragment, { children: content.map(function (e, i) { return (_jsxs(Fragment, { children: [_jsx(GridHeader, { children: e.label }, void 0),
                                    _jsx(Grid, { children: e.items.map(function (item, j) { return (_jsxs(Tile, { children: [_jsx(TileHeader, { children: item.label }, void 0),
                                                _jsx(TileComment, { children: item.comment }, void 0)] }, j)); }) }, void 0)] }, i)); }) }, void 0) }), void 0)] }, void 0)] }, void 0));
}
//# sourceMappingURL=OrganizationHome.js.map